var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.08471C16 6.5453 16.2615 6.03737 16.7059 5.71373C19.8431 3.42876 24.1569 3.42876 27.2941 5.71373C27.7385 6.03737 28 6.5453 28 7.08471V23.3333C28 24.4379 27.1046 25.3333 26 25.3333H18.5694C17.8119 25.3333 17.1193 25.7613 16.7805 26.4389L16.0894 27.8211C16.0526 27.8948 15.9474 27.8948 15.9106 27.8211L15.2195 26.4389C14.8807 25.7613 14.1881 25.3333 13.4306 25.3333H6C4.89543 25.3333 4 24.4379 4 23.3333V7.08471C4 6.5453 4.26152 6.03737 4.70588 5.71373C7.84314 3.42876 12.1569 3.42876 15.2941 5.71373C15.7385 6.03737 16 6.5453 16 7.08471ZM16 7.08471V26.6667",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.5fef2e85d31a5744a2b9b607cf959d40.svg";
export { ForwardRef as ReactComponent };